module.exports = __webpack_public_path__ + "Flag-268.65d32e8dc661d2901e69b3afe3fea9ad.svg";